import { Provider } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, RouteReuseStrategy } from '@angular/router';

class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futureComponent = future.routeConfig?.component;
    const currComponent = curr.routeConfig?.component;

    if (futureComponent && currComponent) {
      return futureComponent === currComponent;
    }

    return future.routeConfig === curr.routeConfig;
  }
}

export function provideRouteReuseStrategy(): Provider[] {
  return [{
    provide: RouteReuseStrategy,
    useClass: CustomRouteReuseStrategy,
  }];
}
